// Store confirmed requests before sending them. IndexedDB accommodates event-sized
// payloads without sessionStorage's small synchronous string quota.
const DATABASE = 'coreevent-refund-recovery'
const STORE = 'requests'
function access(mode, action) {
  return new Promise((resolve, reject) => {
    let database, transaction, settled = false, result
    const finish = (error) => {
      if (settled) return
      settled = true; clearTimeout(timer)
      if (database) database.close()
      if (error) reject(error)
      else resolve(result)
    }
    const timer = setTimeout(() => {
      if (transaction) { try { transaction.abort() } catch (_) {} }
      finish(new Error('Recovery storage timed out'))
    }, 5000)
    try {
      const open = indexedDB.open(DATABASE, 1)
      open.onupgradeneeded = () => {
        if (!open.result.objectStoreNames.contains(STORE)) open.result.createObjectStore(STORE)
      }
      open.onerror = () => finish(open.error || new Error('Recovery storage unavailable'))
      open.onblocked = () => finish(new Error('Recovery storage blocked'))
      open.onsuccess = () => {
        database = open.result
        if (settled) { database.close(); return }
        try {
          transaction = database.transaction(STORE, mode)
          transaction.oncomplete = () => finish()
          transaction.onabort = () => finish(transaction.error || new Error('Recovery write aborted'))
          transaction.onerror = () => finish(transaction.error || new Error('Recovery storage failed'))
          const request = action(transaction.objectStore(STORE))
          request.onsuccess = () => { result = request.result }
          request.onerror = () => finish(request.error || new Error('Recovery storage failed'))
        } catch (error) { finish(error) }
      }
    } catch (error) { finish(error) }
  })
}
export const saveEventRefundRecovery = (id, value) => access('readwrite', store => store.put(value, id))
export const loadEventRefundRecovery = id => access('readonly', store => store.get(id))
export const removeEventRefundRecovery = id => access('readwrite', store => store.delete(id))
